import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { AboutDhadukFamilyComponent } from './about-dhaduk-family.component';


@NgModule({
  declarations: [
    AboutDhadukFamilyComponent
  ],
  imports: [
    CommonModule,
    SharedModule,

  ]
})
export class AboutDhadukFamilyModule { }
